import React from 'react';
import { Gradient } from '../Gradient';

const SheetFile = ({ type, className = '', color = '#737373' }) => {
  return (

<svg width="16" height="21" viewBox="0 0 16 21" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
<path d="M15.0078 8.00391H10.3385C9.04916 8.00391 8.00391 6.95865 8.00391 5.66927V1M3.33464 13.8405V16.7588C3.33464 17.0811 3.59595 17.3424 3.91829 17.3424H8.00391M3.33464 13.8405V10.9222C3.33464 10.5999 3.59595 10.3385 3.91829 10.3385H8.00391M3.33464 13.8405H8.00391M12.6732 13.8405V10.9222C12.6732 10.5999 12.4119 10.3385 12.0895 10.3385H8.00391M12.6732 13.8405V16.7588C12.6732 17.0811 12.4119 17.3424 12.0895 17.3424H8.00391M12.6732 13.8405H8.00391M8.00391 13.8405V10.3385M8.00391 13.8405V17.3424M15.0078 7.80363V17.3424C15.0078 18.6318 13.9626 19.6771 12.6732 19.6771H3.33464C2.04525 19.6771 1 18.6318 1 17.3424V3.33464C1 2.04525 2.04525 1 3.33464 1H8.20419C8.82337 1 9.41719 1.24597 9.85502 1.6838L14.324 6.15279C14.7618 6.59062 15.0078 7.18444 15.0078 7.80363Z" 
stroke={type === 'plain' ? color : 'url(#globalGradient)'}
      strokeWidth="1" 
      strokeLinecap="round" 
      strokeLinejoin="round"/>
      <Gradient className={className} />
</svg>


  );
};

export default SheetFile;